import { createAction } from 'redux-actions';

import * as types from './types';

// GET app
export const getApp = createAction(types.GET_APP);

export const cleanFetchError = createAction(types.CLEAN_FETCH_ERROR);
export const setFetchError = createAction(types.SET_FETCH_ERROR);

export const getPublicAppointments = createAction(types.GET_PUBLIC_APPOINTMENTS);

/**
 * Action for set current app
 */
export const setCurrentApp = createAction(types.SET_CURRENT_APP);
